import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";

export default function Login() {
  const { user, checking, login } = useAuth();
  const [survivorId, setSurvivorId] = useState("S-04112");
  const [password, setPassword] = useState("password");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (!checking && user) return <Navigate to="/" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(survivorId.trim(), password);
      navigate(location.state?.from || "/", { replace: true });
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-form-wrap">
          <div className="login-card-top">
            <p className="eyebrow">CHIKITOKA / IDENTITY VERIFICATION</p>
            <div className="signal-bars" aria-hidden="true"><i /><i /><i /><i /><i /></div>
          </div>
          <h2>생존자 인증</h2>
          <p>GB-33-A 폐쇄망에 접속합니다. 등록된 생존자 ID와 암호를 입력하십시오.</p>
          <form onSubmit={submit}>
            <div className="field">
              <label htmlFor="survivor-id">생존자 ID</label>
              <input id="survivor-id" value={survivorId} onChange={(e) => setSurvivorId(e.target.value)} autoComplete="username" required />
            </div>
            <div className="field">
              <label htmlFor="password">접속 암호</label>
              <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
            </div>
            {error && <div className="login-error" role="alert">! {error}</div>}
            <button className="login-submit" type="submit" disabled={submitting}>{submitting ? "인증 중..." : "내부망 접속"}</button>
          </form>
          <div className="auth-switch">생존자 기록이 없습니까? <Link to="/register">[신규 생존자 등록]</Link></div>
          <p className="demo-note">초기 계정: S-04112 / password · 배포 후 반드시 암호를 변경하십시오.</p>
          <dl className="login-meta">
            <div><dt>NODE</dt><dd>GB-33-A</dd></div>
            <div><dt>STATUS</dt><dd>DEGRADED</dd></div>
            <div><dt>UPTIME</dt><dd>0412:08:33</dd></div>
          </dl>
        </div>
      </section>
    </main>
  );
}
